import { Character } from "../types/types";

const InitPerson:Character[]= [
    {
      id: 1,
      svgUrl: "/img/stevehotel/robots/1.svg",
      svgDPurl: "/img/stevehotel/robots/1dp.svg",
    },
    {
      id: 2,
      svgUrl: "/img/stevehotel/robots/2.svg",
      svgDPurl: "/img/stevehotel/robots/2.svg",
    },
    {
      id: 3,
      svgUrl: "/img/stevehotel/robots/3.svg",
      svgDPurl: "/img/stevehotel/robots/3dp.svg",
    },
    {
      id: 4,
      svgUrl: "/img/stevehotel/robots/4.svg",
      svgDPurl: "/img/stevehotel/robots/4.svg",
    },
    {
      id: 5,
      svgUrl: "/img/stevehotel/robots/5.svg",
      svgDPurl: "/img/stevehotel/robots/5.svg",
    },
    {
      id: 6,
      svgUrl: "/img/stevehotel/robots/6.svg",
      svgDPurl: "/img/stevehotel/robots/6dp.svg",
    },
    {
      id: 7,
      svgUrl: "/img/stevehotel/robots/7.svg",
      svgDPurl: "/img/stevehotel/robots/7.svg",
    },
    {
      id: 8,
      svgUrl: "/img/stevehotel/robots/8.svg",
      svgDPurl: "/img/stevehotel/robots/8.svg",
    },
    {
      id: 9,
      svgUrl: "/img/stevehotel/robots/9.svg",
      svgDPurl: "/img/stevehotel/robots/9dp.svg",
    },
    {
      id: 10,
      svgUrl: "/img/stevehotel/robots/10.svg",
      svgDPurl: "/img/stevehotel/robots/10dp.svg",
    },
  ];
  
export default InitPerson